import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Calendar, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { useTimezone } from '@/contexts/TimezoneContext';

export function LiveClock() {
  const [now, setNow] = useState(new Date());
  const { useFranceTime, setUseFranceTime, formatInTimezone } = useTimezone();

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const displayTime = formatInTimezone(now);

  return (
    <div className="hidden md:flex items-center gap-4 text-sm text-muted-foreground">
      <div className="flex items-center gap-1.5">
        <Calendar className="h-4 w-4" />
        <span className="font-medium">
          {format(displayTime, 'EEEE d MMMM', { locale: fr })}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <Clock className="h-4 w-4" />
        <span className="font-mono tabular-nums">
          {format(displayTime, 'HH:mm:ss')}
        </span>
      </div>
      
      {/* France flag toggle */}
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className={cn(
              'h-7 w-7 p-0 text-lg transition-all',
              useFranceTime ? 'bg-accent ring-2 ring-primary/20' : 'grayscale opacity-50 hover:grayscale-0 hover:opacity-100'
            )}
            onClick={() => setUseFranceTime(!useFranceTime)}
          >
            🇫🇷
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {useFranceTime ? 'Heure de France (Paris) activée' : 'Passer à l\'heure de France'}
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
